module.exports = __webpack_public_path__ + "static/Dance Intensives_compressed-f0b9f1199a2331b0e9ee2cb64a53fbf0.pdf";